/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from "@common-ui/ui";
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { getSessionToken } from "../../services/getToken";
import { workItemsSlice } from "../../reducers/workItemsReducer";

import { config } from "../../configs";

const Iframe = styled("iframe")`
  opacity: 1;
  z-index: 1;
  background-color: white;
  user-select: initial;
  pointer-events: initial;
  width: 100%;
  /* height: 100vh; */
  border-width: 0px;
  min-height: 0px;
  overflow: auto;
  overflow-x: scroll;
`;
const FrameRenderer = ({ url, ...props }) => {
  const dispatch = useDispatch();
  const iframeRef = React.useRef();
  const [size, setSize] = useState({ width: "100%", height: "100vh" });
  const [src, setSrc] = useState(
    `${url}?step=${props?.stepNum}&mode=${props?.mode}`
  );
  const [isLoading, setIsLoading] = useState(true);
  const [isInit, setIsInit] = useState(false);
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [tokens, setTokens] = useState({});

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    setIsLoading(false);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
  useEffect(() => {
    // console.log("reload", props?.mode);
    setIsLoading(true);
    // iframeRef?.current?.contentWindow?.location?.reload(true);
    setSrc(`${url}?step=${props?.stepNum}&mode=${props?.mode}`);
    forceUpdate();
    window.addEventListener("message", handleMessage);
    setIsLoading(false);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [props?.mode]);
  const handleMessage = async (event) => {
    const messageType = event.data?.messageType;
    const messageData = event.data?.message;
    switch (messageType) {
      case `READY`:
        // if (String(iframeRef.current.id) !== String(props?.stepNum)) return;
        let authToken = await getSessionToken();
        setTokens(authToken);
        // Initialization message - sent by iFrame parent after receiving ready message
        iframeRef?.current?.contentWindow.postMessage(
          {
            messageType: "INITIALIZATION",
            message: {
              application: "Baseline",
              organization: props?.performing_org,
              workEventId: props?.work_event,
              workItemId: props?.id,
              stepNumber: props?.stepNum,
              equipment: props.equipment,
              configuration: props?.configuration,
              authToken,
              platConfig: config,
              mode: props?.mode || "INTERACTIVE",
            },
          },
          event.origin
        );
        setIsInit(true);
        break;
      case "HEIGHT":
        if (String(iframeRef?.current?.id) !== String(messageData?.stepNum))
          return;
        if (String(props?.id) !== String(messageData?.workItemId)) return;
        setIsInit(true);
        // console.log("HEIGHT", event);
        if (event.data?.message?.height === 0) {
          setSize({ ...size });
          return;
        }
        // console.log("ref", iframeRef);
        // console.log("HEIGHT", event);
        setSize({ ...size, height: event.data?.message?.height });
        break;
      case "STATUS":
        dispatch(
          workItemsSlice.actions.setProcedureStatus({
            workItemId: props?.id,
            status: messageData,
          })
        );
        break;
      default:
        break;
    }
  };

  return isLoading ? (
    "Loading..."
  ) : (
    <Box sx={{ width: "100%", height: "100%" }}>
      <div style={{ height: "100%", position: "relative" }}>
        <Iframe
          style={{ height: size.height }}
          isInit={isInit}
          ref={iframeRef}
          loading="lazy"
          seamless
          sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts allow-downloads allow-pointer-lock allow-top-navigation allow-top-navigation-by-user-activation"
          src={src}
          width={size.width}
          // height={size.height}
          title={props?.stepNum}
          id={props?.stepNum}
          allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
        />
      </div>
    </Box>
  );
};

export { FrameRenderer };
